export const setCurrentRecordIdHelper = ({
  query,
  paramResource,
  paramId,
  reduxId,
  reduxAction
}) => {
  // if we have a paramId and no reduxId has been set, then use the param
  if (paramResource === 'records' && paramId && !reduxId) {
    reduxAction(paramId);
  // else if we have activeRecords and no reduxId has been set, then use the first record id from the data
  } else if (!query.isLoading && !reduxId) {
    const recordPages = query.data.pages;

    if (recordPages.length) {
      const recordPageData = recordPages[0].data;

      if (recordPageData.length) {
        const firstRecordId = recordPageData[0].id;

        reduxAction(firstRecordId);
      }
    }
  }

  // if none of the above are satisfied, we never set the currentRecordId
};
